import React from 'react'
import { isEmpty } from 'lodash'

import { Table } from 'components'
import { THead, TBody, ActionEventTable } from 'components/Table'
import { IColumn, ISorting } from 'types'
import {
  ProductHistory,
  TicketProductHistoryCollapse,
  TicketProductHistorySingle,
} from '..'

type PropsTicketProductHistoriesBody = {
  columns: IColumn[]
  isError: boolean
  isLoading: boolean
  histories: ProductHistory[]
  sorting: ISorting
  handleSortChange: (sort: ISorting) => void
}

const TicketProductHistoryBody: React.FC<PropsTicketProductHistoriesBody> = (
  props: PropsTicketProductHistoriesBody,
) => {
  const {
    columns,
    isLoading,
    isError,
    histories,
    sorting,
    handleSortChange = () => {},
  } = props

  const base = 'f-ticket-product-history-modal'

  const dataTable = () => {
    if (isLoading) {
      return <ActionEventTable colSpan={columns.length} isLoading />
    }

    if (isEmpty(histories) || isError) {
      return <ActionEventTable colSpan={columns.length} isNotFound />
    }

    return (
      <TBody>
        {histories
          .filter((history) => !!history.task)
          .map((history, index) => (
            <TicketProductHistorySingle
              key={index}
              history={history}
              columns={columns}
              render={(id) =>
                histories.map(({ id: historyId, checklist }, index) => (
                  <TicketProductHistoryCollapse
                    key={index}
                    selectedId={id}
                    historyId={historyId}
                    checklist={checklist}
                  />
                ))
              }
            />
          ))}
      </TBody>
    )
  }

  return (
    <Table className={`${base}__main-table`}>
      <THead
        columns={columns}
        onSortChange={handleSortChange}
        sorting={sorting}
      />
      {dataTable()}
    </Table>
  )
}

export default TicketProductHistoryBody
